(() => {
  if (window.ilCalendlyButtons) return;
  window.ilCalendlyButtons = true;
  let loading;
  let opening = false;
  function loadWidget() {
    if (!document.querySelector('link[href*="assets.calendly.com/assets/external/widget.css"]')) {
      const css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://assets.calendly.com/assets/external/widget.css';
      document.head.appendChild(css);
    }
    if (window.Calendly && typeof window.Calendly.initPopupWidget === 'function') {
      return Promise.resolve(window.Calendly);
    }
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      let script = document.querySelector('script[src*="assets.calendly.com/assets/external/widget.js"]');
      const created = !script;
      if (created) {
        script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;
      }
      let timer;
      const cleanup = () => {
        clearTimeout(timer);
        script.removeEventListener('load', loaded);
        script.removeEventListener('error', failed);
      };
      const failed = () => { cleanup(); reject(new Error('Calendly unavailable')); };
      const loaded = () => {
        cleanup();
        if (window.Calendly && typeof window.Calendly.initPopupWidget === 'function') resolve(window.Calendly);
        else reject(new Error('Calendly unavailable'));
      };
      script.addEventListener('load', loaded, { once: true });
      script.addEventListener('error', failed, { once: true });
      timer = setTimeout(failed, 15000);
      if (created) document.head.appendChild(script);
    });
    return loading;
  }
  document.addEventListener('click', async (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.hasAttribute('download')) return;
    let url;
    try { url = new URL(link.href, window.location.href); } catch { return; }
    if (url.protocol !== 'https:' || url.hostname !== 'calendly.com') return;
    if (!link.hasAttribute('data-calendly-popup') && url.pathname.replace(/\/$/, '') !== '/contact-iliveheredesign/30min') return;
    for (const key of ['background_color', 'text_color', 'primary_color']) {
      const malformed = 'amp;' + key;
      if (url.searchParams.has(malformed)) {
        if (!url.searchParams.has(key)) url.searchParams.set(key, url.searchParams.get(malformed));
        url.searchParams.delete(malformed);
      }
    }
    for (const [key, value] of Object.entries({ background_color: 'ffffff', text_color: '3d3d3d', primary_color: '804a01' })) {
      if (!url.searchParams.has(key)) url.searchParams.set(key, value);
    }
    event.preventDefault();
    if (opening) return;
    opening = true;
    link.setAttribute('aria-busy', 'true');
    try {
      const widget = await loadWidget();
      widget.initPopupWidget({ url: url.href });
    } catch {
      window.location.assign(url.href);
    } finally {
      opening = false;
      link.removeAttribute('aria-busy');
    }
  });
})();
